// extracted by mini-css-extract-plugin
export var actionButton = "_rd-0";
export var actionMenuContainer = "_rd-i";
export var bubble = "_rd-2";
export var bubbleActionMenu = "_rd-j";
export var bubbleContext = "_rd-6";
export var bubbleItems = "_rd-7";
export var customer = "_rd-3";
export var divider = "_rd-8";
export var fileList = "_rd-9";
export var hiddenComment = "_rd-o";
export var infoAbove = "_rd-a";
export var internal = "_rd-4";
export var lightActionButton = "_rd-1";
export var link = "_rd-b";
export var merchant = "_rd-5";
export var message = "_rd-c";
export var profilePicture = "_rd-e";
export var quillToolbarContainer = "_rd-f";
export var senderDate = "_rd-g";
export var senderDateCustomer = "_rd-h";
export var senderName = "_rd-d";
export var time = "_rd-k";
export var uploadedImage = "_rd-l";
export var username = "_rd-m";
export var xsmall = "_rd-n";